var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7691 21.3605C18.3897 21.5897 18.1861 21.7409 18.3091 21.7409V23.3335C18.3091 23.8857 17.8613 24.3335 17.3091 24.3335H12.6909C12.1386 24.3335 11.6909 23.8857 11.6909 23.3335V22.2897C11.6909 21.9479 11.5163 21.6297 11.2279 21.4461L9.40916 20.2884C8.27048 19.5635 7.49815 18.3844 7.28867 17.0509L7.04529 15.5016C6.27663 10.6085 10.1078 6.1853 15.0609 6.1853C19.5892 6.1853 23.2521 9.95044 23.0744 14.4753C22.9611 17.3609 21.2409 19.8671 18.7691 21.3605Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.235 29H14.274C13.1285 29 12.2 28.0714 12.2 26.9259C12.2 25.7804 13.1285 24.8518 14.274 24.8518H16.235C17.3804 24.8518 18.309 25.7804 18.309 26.9259C18.309 28.0714 17.3804 29 16.235 29Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58179 23.8149L6.59997 22.7778",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.03636 14.4814H1",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59997 6.18523L5.58179 5.14819",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2545 3.07407V1",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4 6.18519L24.9273 4.62964",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9636 14.4814H29",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4 22.7778L24.9273 24.3334",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulb);
export default __webpack_public_path__ + "static/media/lightBulb.5b2f7cada0a84ff06427c66348c778f5.svg";
export { ForwardRef as ReactComponent };